import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutContactPreview.css';

const AboutContactPreview = () => {
  const navigate = useNavigate();

  const highlights = [
    { icon: "🌿", title: "Eco-Friendly" },
    { icon: "✋", title: "Handmade" },
    { icon: "♻️", title: "Sustainable" },
    { icon: "🌎", title: "Global Sourcing" }
  ];
  return (
    <section className="about-contact-preview-section">
      <div className="about-contact-overlay" />

      <div className="about-contact-content">
        <div className="about-contact-card">
          <h2 className="about-contact-title">
            Infuse Your World With Nature's Elegance
          </h2>
          
          <p className="about-contact-tagline">
            Discover our sustainable botanical creations and connect with our team for personalized solutions.
            Let us bring nature's beauty into your space with our carefully crafted designs.
          </p>

          <div className="about-contact-highlights">
            {highlights.map((h, i) => (
              <div key={i} className="highlight-item">
                <span className="highlight-icon">{h.icon}</span>
                <span className="highlight-title">{h.title}</span>
              </div>
            ))}
          </div>

          <div className="preview-buttons">
            <button
              className="preview-button about-button"
              onClick={() => navigate('/about')}
            >
              Our Story
            </button>
            
            <button
              className="preview-button contact-button"
              onClick={() => navigate('/contact')}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContactPreview;